import type { PaneKind } from '../../shared/contracts';

/** Loading placeholder shaped like the pane it will become. */
export function PaneSkeleton({ kind }: { kind: PaneKind }) {
  return (
    <div className="h-full rounded-brand border border-brand-primary/10 bg-white p-5 shadow-sm">
      <div className="animate-pulse">
        <div className="mb-4 flex items-start justify-between">
          <div className="space-y-2">
            <div className="h-2 w-12 rounded bg-brand-primary/10" />
            <div className="h-3.5 w-32 rounded bg-brand-primary/15" />
          </div>
          <div className="h-3 w-3 rounded-full bg-brand-primary/10" />
        </div>
        {kind === 'metric' && (
          <>
            <div className="h-9 w-24 rounded bg-brand-primary/15" />
            <div className="mt-4 h-24 rounded bg-brand-primary/5" />
          </>
        )}
        {kind === 'progress' && <div className="mx-auto mt-2 h-32 w-32 rounded-full border-[10px] border-brand-primary/10" />}
        {(kind === 'list' || kind === 'ranking') && (
          <div className="space-y-3">{[0, 1, 2, 3, 4].map((i) => <div key={i} className="h-8 rounded bg-brand-primary/5" />)}</div>
        )}
        {kind === 'agenda' && (
          <div className="space-y-3">{[0, 1, 2].map((i) => <div key={i} className="h-11 rounded bg-brand-primary/5" />)}</div>
        )}
      </div>
    </div>
  );
}
